import { CommonModule } from '@angular/common';
import { Component, inject, Injector, OnInit } from '@angular/core';
import { DwGridDataSourceService, FieldTypes } from '@digiwall/ag-grid';
import { CustomerInvoiceListDto, CustomerInvoiceService } from '@digiwall/goliath-documents/proxy';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { ColDef } from '@ag-grid-community/core';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';
import { GoliathCoreEnumerationTypeStore } from '@digiwall/goliath-core';
import { ColumnDefinitionsService } from '../../../services';
import { BaseInvoiceDocList } from '../../base-invoice-docs/base-invoice-doc-list';
import { Observable } from 'rxjs';
import { LoadingService } from '@digiwall/core';

@Component({
  selector: 'document-customer-invoice-list',
  templateUrl: './customer-invoice-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class CustomerInvoiceListComponent
  extends BaseInvoiceDocList<CustomerInvoiceListDto, CustomerInvoiceService>
  implements OnInit
{
  protected readonly enumerationTypeStore = inject(GoliathCoreEnumerationTypeStore);

  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      colId: 'VCS',
      field: 'vcs',
      headerName: this.localizationService.instant('Doc::CustomerInvoice:VCS'),
      type: FieldTypes.String,
    },
    {
      field: 'totalPayment',
      headerName: this.localizationService.instant('Doc::CustomerInvoice:TotalPayment'),
      type: FieldTypes.Currency,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    customerInvoiceService: CustomerInvoiceService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
    columnDefinitionService: ColumnDefinitionsService,
    loadingService: LoadingService,
  ) {
    super(
      customerInvoiceService,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
      columnDefinitionService,
      loadingService,
    );

    this.service.hasPeppolConfiguration().subscribeOnce(
      hasPeppolConfiguration => {
        this.hasPeppolConfiguration.set(hasPeppolConfiguration);
      },
      () => {
        this.hasPeppolConfiguration.set(false);
      },
    );
  }

  protected override generateUBLThenSendMultipleObservable(ids: string[]): Observable<number> {
    return this.service.generateUBLThenSendMultiple(this.selectedEntities().map(x => x.id));
  }
}
